package com.islamicmedia.site.pages.isitsafe

import androidx.compose.runtime.Composable
import com.islamicmedia.site.components.PublicReviewPage
import com.varabyte.kobweb.core.Page

/** Public SEO review — "/isitsafe/toy-story-5". Pulls the REAL cached analysis (baked in StaticReviews). */
@Page("/isitsafe/toy-story-5")
@Composable
fun ToyStory5ReviewPage() {
    PublicReviewPage(
        slug = "toy-story-5",
        blurb = "Is Toy Story 5 OK for Muslim kids? Fitrah Filter checks movies, shows, games, and books against Islamic values. Here's the full breakdown for parents.",
    )
}
